module.exports = __webpack_public_path__ + "img/1.80a1f1b5.png";